export const MODELLER_PROFILE_TABINDEX = 0;
export const MODELLER_OUTPUT_TABINDEX = 1;
